import { useAuth } from "react-oidc-context";
import { LogoutIcon } from "./../assets/icons";

export default function User() {
  const auth = useAuth();
  let initials = "";
  if (auth.user) {
    initials = (
      auth.user.profile.given_name[0] + auth.user.profile.family_name[0]
    ).toUpperCase();
  }
  return (
    <div className="user">
      <div className="avatar">
        <div className="avatarText">{initials}</div>
      </div>
      <div
        onClick={() => {
          void auth.signoutRedirect({
            post_logout_redirect_uri: 'http://localhost:20058',
        });
        }}
        style={{ cursor: "pointer" }}
      >
        <LogoutIcon />
      </div>
    </div>
  );
}
